export const environment = {
  production: false,
  ApiAppUrl: 'https://fcmgyapitest.clavisco.com/',
  ApiUIUrl: 'https://fcmgytest.clavisco.com/',
  env: 'Staging',
  recatchaSiteKey: '6LeAroIrAAAAAP1WO6xyw3D8AqHH27qjp82sRjo6',
  LogRocketId: ''
};
